import React from 'react';
import clsx from 'clsx';

interface DialogBodyProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Content wrapper for footer-less dialogs, i.e. `openDialog(content, onSave, true)`.
 *
 * For that variant DialogLayout keeps the OK button clear by putting `mx-16` on
 * the content wrapper, which costs 64px on both sides and leaves a narrow
 * column. The button only ever sits in the top right corner, so this gives the
 * content the dialog's full width back and keeps out of the button's way with
 * top padding instead.
 */
const DialogBody: React.FC<DialogBodyProps> = ({ children, className }) => (
  <div className={clsx('-mx-16 px-2 pt-2', className)}>{children}</div>
);

export default DialogBody;
